module.exports = __webpack_public_path__ + "img/values.691ff51.svg";